import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { GameModel } from '../../../Models/GameModel';
import { ButtonController } from '../../../Common/ButtonController';
import { GreenButtonTextStyle, RedButtonTextStyle, TitleTextStyle } from '../../../Constants/TextStyles';
import { GameEvent, GameEventPopupButtonName, GameEventPopupName } from '../../../Constants/GameEvent';

export interface IConfirmationsConfirmControllerOptions {
    oneButtonMode: boolean;
    text: 'A you sure?',
    yesText?: 'YES',
    noText?: 'NO',
    yesClick?: () => {},
    noClick?: () => {}
}

export class ConfirmationsConfirmController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IConfirmationsConfirmControllerOptions,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('ConfirmationsConfirmController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CONFIRMATIONS_JSON,
            libraryName: 'confirmations_container',
            childControllers: {
                modal_confirm_yes: {
                    controller: ButtonController,
                    instanceName: 'confirmations.modal_confirm.modal_confirm_cancel',
                    options: {
                        label: this._options.yesText || '',
                        onClick: () => {
                            if (this._options.yesClick) {
                                this._options.yesClick();
                            }
                        },
                    },
                },
                modal_confirm_no: {
                    controller: ButtonController,
                    instanceName: 'confirmations.modal_confirm.modal_confirm_exit',
                    options: {
                        label: this._options.noText || '',
                        onClick: () => {
                            if (this._options.noClick) {
                                this._options.noClick();
                            }
                        },
                    },
                },
            },
        };
    }

    protected onInitialize() {
        this.init();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public init(): void {
        if (typeof this._options.oneButtonMode === 'undefined') {
            this._options.oneButtonMode = false;
        }

        this.gotoAndStopByQuery('confirmations', 'modal_confirm');

        this.setTextByQuery('confirmations.modal_confirm.modal_confirm_title', this._options.text || '');
        this.setTextVerticalAlignByQuery('confirmations.modal_confirm.modal_confirm_title', 'middle');
        this.setTextStyleByQuery('confirmations.modal_confirm.modal_confirm_title', TitleTextStyle);

        this.setTextByQuery('confirmations.modal_confirm.modal_confirm_cancel.label', this._options.yesText || '');
        this.setTextByQuery('confirmations.modal_confirm.modal_confirm_cancel.txt_price', this._options.yesText || '');

        this.setTextStyleByQuery('confirmations.modal_confirm.modal_confirm_cancel.label', GreenButtonTextStyle);
        this.setTextStyleByQuery('confirmations.modal_confirm.modal_confirm_cancel.txt_price', GreenButtonTextStyle);

        this.setTextByQuery('confirmations.modal_confirm.modal_confirm_exit.label', this._options.noText || '');
        this.setTextByQuery('confirmations.modal_confirm.modal_confirm_exit.txt_price', this._options.noText || '');

        this.setTextStyleByQuery('confirmations.modal_confirm.modal_confirm_exit.label', RedButtonTextStyle);
        this.setTextStyleByQuery('confirmations.modal_confirm.modal_confirm_exit.txt_price', RedButtonTextStyle);

        if (this._options.oneButtonMode) {
            this.$childControllers.get('modal_confirm_yes').visible = true;
            this.$childControllers.get('modal_confirm_yes').x = 0;
            this.$childControllers.get('modal_confirm_no').visible = false;

        } else {
            this.$childControllers.get('modal_confirm_yes').visible = true;
            this.$childControllers.get('modal_confirm_yes').x = -201;

            this.$childControllers.get('modal_confirm_no').visible = true;
            this.$childControllers.get('modal_confirm_no').x = 201;
        }
    }
}
